import { API } from "./api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Login nativo con Google (cliente OAuth propio). El backend redirige a Google y de vuelta
// a /auth/callback?token=... con la sesión creada (identidad + scope calendar.events).
export function startGoogleLogin() {
  if (localStorage.getItem("session_token")) {
    window.location.href = window.location.origin + "/dashboard";
    return;
  }
  const origin = window.location.origin;
  window.location.href = `${API}/auth/google/login?origin=${encodeURIComponent(origin)}`;
}
